import { ServiceTemplatesState } from "@idw-types/state/service-templates-state";
import { ServiceTemplatesActions, ServiceTemplatesActionTypes } from "@redux/actions/service-templates-actions";

export const initialServiceTemplatesState: ServiceTemplatesState = {
    data: {
        isLoading: false,
        serviceTemplates: null
    }
};

export const serviceTemplatesReducer = (
    state: ServiceTemplatesState = initialServiceTemplatesState,
    action: ServiceTemplatesActions
): ServiceTemplatesState => {
    switch (action.type) {
        // Service Templates
        case ServiceTemplatesActionTypes.SET_SERVICE_TEMPLATES_LOADING:
            return {
                ...state,
                data: {
                    ...(action.payload.isLoading
                        ? { ...initialServiceTemplatesState.data }
                        : { ...state.data }),
                    isLoading: action.payload.isLoading
                }
            };
        case ServiceTemplatesActionTypes.SET_SERVICE_TEMPLATES:
            return {
                ...state,
                data: {
                    ...state.data,
                    serviceTemplates: action.payload.serviceTemplates,
                    isLoading: false
                }
            };
        case ServiceTemplatesActionTypes.ADD_SERVICE_TEMPLATE:
            
            return {
                ...state,
                data: {
                    ...state.data,
                    serviceTemplates: state.data.serviceTemplates
                        ? [...state.data.serviceTemplates, action.payload.serviceTemplate]
                        : [action.payload.serviceTemplate]
                }
            };
        default:
            return state;
    }
};